import styled, { keyframes } from 'styled-components';
import { COLORS } from '../../../styles/variables';
import { device } from '../../../styles/devices';

export const IconWrapper = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  position: absolute;
  right: 28px;
  top: 16px;
  @media ${device.mobileL} {
    right: 60px;
  }
`;

export const SearchWrapper = styled.section`
  max-width: 500px;
  height: 100vh;
  background-color: white;
  position: fixed;
  right: 0;
  top: 0;
  padding: 0;
  overflow-y: auto;
  z-index: 1000;
  box-sizing: border-box;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  &::after {
    content: '';
    display: block;
    height: 28px;
  }
`;

export const BlackBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 999;
`;

export const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
  padding: 12px 28px 4px 28px;
`;

export const CloseWrapper = styled.div`
  padding-top: 4px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;

  button {
    padding-right: 0;
    padding-top: 0;
    padding-bottom: 0;
    min-height: 24px;
    align-items: flex-start;
  }

  @media ${device.mobileL} {
    padding-bottom: 28px;
  }
`;

export const TabsWrapper = styled.div`
  padding: 0 16px;

  & > div > div:not(:first-child) {
    padding: 0;
    padding-top: 8px;
  }

  @media ${device.mobileL} {
    padding: 0 28px;
  }
`;

export const ListOfVehicles = styled.ul`
  padding-left: 0;
  display: flex;
  flex-direction: column;
  margin: 0;
  gap: 8px;
  & > div {
    padding: 12px;
  }
`;

export const CardWrapper = styled.a<{ vlpCard?: boolean }>`
  cursor: pointer;
  color: inherit;
  text-decoration: none;
  transition: box-shadow 0.2s ease;
  border-radius: 4px;
  min-width: 343px;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  > div {
    height: ${({ vlpCard }) => (vlpCard ? '74px' : '124px')};
    min-width: 343px;
    padding: 12px;
  }

  @media ${device.mobileL} {
    width: 445px;
    > div {
      width: 445px;
      height: ${({ vlpCard }) => (vlpCard ? '78px' : '144px')};
    }
  }
`;

export const CardContentWrapper = styled.div<{ vlpCard?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const ImageWrapper = styled.div`
  width: 133px;
  min-width: 133px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  overflow: hidden;

  @media ${device.mobileL} {
    width: 158px;
    min-width: 158px;
    height: 120px;
  }
`;

export const Image = styled.img`
  width: 100%;
`;
export const VehicleData = styled.div<{ gap?: number; vlpCard?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => (gap ? `${gap}px` : '12px')};

  @media ${device.mobileL} {
    gap: ${({ gap }) => (gap ? `${gap}px` : '24px')};
  }
`;

export const NameMileage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .mileage {
    color: #666;
  }
`;

export const ClampedText = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;

  @media ${device.mobileL} {
    font-size: 16px;
  }
`;

export const RedirectCta = styled.div``;

export const ViewAllResults = styled.div`
  display: flex;
  flex-direction: row;
`;

export const NoResultsWrapper = styled.section`
  padding: 28px 16px 0 16px;

  @media ${device.mobileL} {
    padding: 28px 28px 0 28px;
  }
`;
export const NoResultsHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 28px;
`;

//------------------------- Spinner ----------------------//
interface StyleProps {
  size: number | undefined;
}

const spin = keyframes`
  to { transform: rotate(360deg) }
`;

export const SpinnerWrapper = styled.div`
  height: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledSpinner = styled.div<StyleProps>`
  display: inline-block;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  border: 3px solid ${COLORS.grey15};
  border-radius: 50%;
  border-top-color: ${COLORS.audiRed};
  animation: ${spin} 1s ease-in-out infinite;
`;
